import React from "react";

const CheckEmail = () => (
    <section className="w-100 p-4 d-flex justify-content-center pb-4">
        <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div className="card border-0 shadow rounded-3 my-5">
                <div className="card-body p-4 p-sm-5">
                    <h5 className="card-title text-center mb-3 fw-light fs-5">Check your email</h5>

                </div>
            </div>
        </div>
    </section>
);

export default CheckEmail;